import ErrorPresenter from '../service/ErrorPresenter';
import ErrorReporter from '../service/ErrorReporter';

class ApiErrorHandler {
  private errorPresenter: ErrorPresenter;
  private errorReporter: ErrorReporter;

  constructor({ errorPresenter, errorReporter }: { errorPresenter: ErrorPresenter; errorReporter: ErrorReporter }) {
    this.errorPresenter = errorPresenter;
    this.errorReporter = errorReporter;
  }

  ERRORS_4XX = ['active_record/record_invalid'];

  // TODO: 型指定どうするの
  public handle = (err: Error | any) => {
    console.log(err);
    if (err.response && err.response.data && err.response.data.code) {
      // const code = err.response.data.code;
      const error: any = new Error(err.response.data.error); // TODO: 型
      error.is_raw = true;
      this.errorPresenter.showAsNonFatal(error);
    } else {
      this.errorReporter.reportError(err);
      this.errorPresenter.showAsFatal(new Error('error.system_error'));
    }
  };
}

export default ApiErrorHandler;
